import { Card } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  RispostaE002OK,
  TipoDatiSoggettiEnte
} from 'server/schema/integrations/pdnd/schema/schemas';
import { PDNDProfileView } from './PDNDProfileView';
import { PDNDResponseWarningList } from './warning/PDNDResponseWarningList';
import { PDNDResponseCitizenList } from './list/PDNDResponseCitizenList';
import { PDNDResponseSourceDrawerButton } from './list/PDNDResponseSourceDrawerButton';

interface IPDNDResponseListViewProps {
  profile?: RispostaE002OK | null;
}

export function PDNDResponseListView(props: IPDNDResponseListViewProps) {
  const { profile } = props;
  const { t } = useTranslation();

  const [citizen, setCitizen] = useState<TipoDatiSoggettiEnte | undefined>(
    undefined
  );

  useEffect(() => {
    const singleCitizen =
      profile?.listaSoggetti?.datiSoggetto &&
      profile?.listaSoggetti?.datiSoggetto?.length === 1
        ? profile?.listaSoggetti?.datiSoggetto[0]
        : undefined;
    setCitizen(singleCitizen);
  }, [profile]);

  if (!profile) return null;

  return (
    <div id="pdnd-response">
      <Card
        title={`Accertamento n: ${profile?.idOperazioneANPR}`}
        extra={<PDNDResponseSourceDrawerButton profile={profile} />}
      >
        <PDNDResponseWarningList warnings={profile?.listaAnomalie} />
        <PDNDResponseCitizenList
          citizens={profile?.listaSoggetti?.datiSoggetto}
          onChargeCitizen={setCitizen}
        />
        <PDNDProfileView citizen={citizen} />
      </Card>
    </div>
  );
}
